import { authFetch } from '../../libs/cookie/Cookie'

import { ContractorType, isValidContractor, getContractorError, getContractorForSubmit } from '../people/contractor/Contractor'
import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'

import { Place } from '../address/AutoSelectionAddress'

import { STEP_1_VALIDATION_URL, ADDRESS_SEARCH_URL } from '../../costants'

export const CONNECTION_ERROR = 'Impossibile verificare i dati. Ti invitiamo a riprovare più tardi.'

export async function basePageOneValidation (
    contractor: ContractorType,
    altriSinistri: boolean | undefined,
    polizzaAttiva: boolean | undefined,
    scadenzaPolizza: string | undefined,

    step_validation_url: string,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    if (!isValidContractor(contractor)) {
        error = 'CONTRACTOR'
    }
    else if (altriSinistri === undefined) {
        error = 'SINISTRI'
    }
    else if (polizzaAttiva === undefined) {
        error = 'POLIZZA'
    }
    else if (
        polizzaAttiva === true && 
        isNotValidScadenzaPolizza(scadenzaPolizza)
    ) {
        error = 'SCADENZA_POLIZZA'
    }
    else {
        await authFetch (
            step_validation_url,
            {
                method: "post",
                body: JSON.stringify({
                    contractor: getContractorForSubmit(contractor),
                    sinistriPrecedenti: altriSinistri,
                    polizzaGiaAttiva: polizzaAttiva,
                    dataScadenza: scadenzaPolizza
                })
            },
            manageExpiredSessionsCallBack,
        ).then ( jsonObj => {
            if (jsonObj.status > 200) {
                error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
            }
        }).catch( error => {
            error = CONNECTION_ERROR
        })
    }

    printErrorCallBack (error)

    return error
}

export async function contractorValidation (
    contractor: ContractorType,
    isLogged: boolean,
    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function,
    ignoreProfession?: boolean | undefined
) {
    let error = getContractorError( contractor, isLogged, ignoreProfession )

    if (error === undefined && contractor.is_manual_address !== true) {
        const abortController = new AbortController()

        await authFetch (
            ADDRESS_SEARCH_URL,
            {
                method: 'post',
                body: JSON.stringify( contractor.indirizzoResidenza_SedeLegale ),
                signal: abortController?.signal
            },
            manageExpiredSessionsCallBack
        ).then( (res: any) => {
            let palces = (res.placeList as Array<any>)

            let hearAddress = contractor.indirizzoResidenza_SedeLegale
            hearAddress = hearAddress?.replace("(", "").replace(")", "")

            if (palces === undefined || !palces.some ( (c: Place) => c.description.toUpperCase() === hearAddress )) {
                console.log (
                    hearAddress,
                    palces
                )
                error = 'CONTRACTOR_ADDRESS_NOT_FOUND'    
            }
        }).catch( async (err) => {
            error = 'CONTRACTOR_ADDRESS_NOT_FOUND'
        })
    }

    if (error === undefined) {
        await authFetch (
            STEP_1_VALIDATION_URL,
            {
                method: "post",
                body: JSON.stringify({
                    contractor: getContractorForSubmit(contractor),
                })
            },
            manageExpiredSessionsCallBack,
        ).then ( jsonObj => {
            if (jsonObj.status > 200) {
                error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
            }
        }).catch( error => {
            error = CONNECTION_ERROR
        })
    }

    printErrorCallBack (error)

    return error
}